import React from "react";
import { Col, Container, Row } from "reactstrap";
import signbg from "../../assets/img/custom/Signbg.jpg";
import posterbg from "../../assets/img/custom/Posterbg.jpg";
import balls from "../../assets/img/custom/balls.png";
import { Link, useHistory } from "react-router-dom";

const Shop = () => {
  const history = useHistory();

  const preventRouting = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <>
      <div
        onClick={history.goBack}
        className="ml-2 ml-md-5 mt-2 backBtn d-flex justify-content-center align-items-center pointer"
      >
        <i className="fas fa-chevron-left fa-lg"></i>
      </div>
      <div className="text-center">
        <a href="#" target="_blank" rel="noopener noreferrer">
          https://youtu.be/Ykj4k5oWBi0
        </a>
      </div>

      <Container>
        <h2 className="text-center mt-4 text-danger">
          Currently Not Available
        </h2>

        <Row className="mt-5">
          <Col md={4}>
            <Link to="/shop/signs" onClick={preventRouting}>
              <div
                className="card p-2"
                style={{ cursor: "not-allowed", opacity: 0.6 }}
              >
                <img className="card-img" src={signbg} height="200px" />
                <div className="card-img-overlay d-flex flex-column justify-content-center">
                  <h4 className="card-title text-white text-center">
                    Buy Scroll Signs
                  </h4>
                </div>
              </div>
            </Link>
          </Col>

          <Col md={4}>
            <Link to="/shop/posters" onClick={preventRouting}>
              <div
                className="card p-2"
                style={{ cursor: "not-allowed", opacity: 0.6 }}
              >
                <img className="card-img" src={posterbg} height="200px" />
                <div className="card-img-overlay d-flex flex-column justify-content-center">
                  <h4 className="card-title text-white text-center">
                    Buy Posters
                  </h4>
                </div>
              </div>
            </Link>
          </Col>

          <Col md={4}>
            <Link to="/shop/signs-and-posters" onClick={preventRouting}>
              <div
                className="card p-2"
                style={{ cursor: "not-allowed", opacity: 0.6 }}
              >
                <img className="card-img" src={balls} height="200px" />
                <div className="card-img-overlay d-flex flex-column justify-content-center">
                  <h4 className="card-title text-white text-center">
                    Buy Both
                  </h4>
                </div>
              </div>
            </Link>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Shop;
